export default {
  CONTRACT_ADDRESS: "0xbE3E97A3d1eCF869Ba922d9ddac27C42fa99a734",
  IS_WHITELISING_OPEN: false,
  MAX_SUPPLY: 4004,
};
